import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cm-folder",
  "use": "icon-cm-folder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cm-folder\"><path d=\"M128 960h768c70.6 0 128-57.4 128-128V320c0-70.6-57.4-128-128-128H576c-20.2 0-39.2-9.4-51.2-25.6l-38.4-51.2C462.2 83 424.2 64 384 64H128C57.4 64 0 121.4 0 192v640c0 70.6 57.4 128 128 128z\" p-id=\"22854\" fill=\"#bfbfbf\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol